import {brand, Branded, TypeOf} from 'io-ts';
import {PositiveInt} from './PositiveInt';

interface AccountIdBrand {
    readonly AccountId: unique symbol;
}

export const AccountId = brand(PositiveInt, (_): _ is Branded<PositiveInt, AccountIdBrand> => true, 'AccountId');

export type AccountId = TypeOf<typeof AccountId>;
